import React from "react";
import { Button, Box, CardActions, Divider } from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { Server as ServerIcon } from "react-feather";
import CardDashboard from "../../components/CardDashboard";
import { useTranslation } from "react-i18next";

const PlantCard = ({ plants, action }) => {
  const { t } = useTranslation();

  return (
    <CardDashboard
      title={t("plant_card.title")}
      value={plants.length}
      avatar={<ServerIcon />}
      action={
        action ? (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                endIcon={<ArrowRightIcon />}
                onClick={action}
              >
                {t("plant_card.action")}
              </Button>
            </CardActions>
          </>
        ) : null
      }
    >
      <Box
        mt={{ xs: 5.5, sm: 10, md: 6.5 }}
        display="flex"
        alignItems="center"
      ></Box>
    </CardDashboard>
  );
};

export default PlantCard;
